import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-dep-com-hall-policy-master',
  templateUrl: './dep-com-hall-policy-master.component.html',
  styleUrls: ['./dep-com-hall-policy-master.component.css']
})
export class DepComHallPolicyMasterComponent {
  displayedColumns = ['id','comhall','category','functionType','openArea','buildArea','secDepo','builtAreaClean','openAreaClean','maximumPer','status','remarks','edit'];
  commShow:boolean;
  openSpaceShow:boolean;
  parkShow:boolean;
  getSpaceType;
  getSpaceTypeForManage
  DepPolicyForm = this.fb.group({
    spaceType: null,
    category: null,
    commhallName: null,
    openArea: null,
    builtArea: null,
    security: null,
    openAreacleaningCharges: null,
    builtAreaCleanCharge: null,
    maxPeriod: null,
    blockageFrom: null,
    blockageTo: null,
    openSpaceName: null,
    spaceTypeManage:null,
    commHall:null,
    openSpace:null,
    parkSel:null,
    permittedActivities:null,
    categoryopenSpace: null,
    typeFunction: null,
    openAreaSpace: null,
    securityDepSpace: null,
    openAreacleaningChargesSpace: null,
    maxPeriodSpace: null,
    blockageFromSpace: null,
    blockageToSpace: null,
    parkName: null,
    categoryPark: null,
    typeFunctionPark: null,
    openAreaPark: null,
    securityDepPark: null,
    openAreacleaningChargesPark: null,
    maxPeriodPark: null,
    blockageFromPark: null,
    blockageToPark: null,
  });
  spaceTypeList;
  categoryList;
  categoryopenSpaceList;
  typeFunctionList;
  categoryParkList;
  typeFunctionParkList;
  spaceTypeManageList;
  commHallList;
  openSpaceList;
  parkSelList;
  seekappointmentList;
  dataSource
 

  constructor(private fb: FormBuilder) {}

  onSubmit() {
    alert('Thanks!');
  }
}
